/* =============================================================================
   wa-pildora.js — La píldora flotante de WhatsApp en móvil y tablet (≤900px)
   Hotel La Gruta · Arequipa · estilos: "BOTÓN FLOTANTE DE WHATSAPP" en site.css

   En móvil la píldora es la de escritorio ("Consultar por WhatsApp", ~245px):
   a ese ancho tapa lo que pasa por la franja baja derecha (el "Ver más" de
   las habitaciones, los enlaces de las tarjetas de Experiencias, el botón
   Consultar del buscador del hero). Por eso se aparta mientras se lee y
   vuelve cuando se la busca:
     · al bajar se oculta (se mete detrás de la barra inferior);
     · al subir vuelve: es el gesto de quien busca algo, también el contacto;
     · mientras el buscador de fechas del hero está a la vista, se oculta:
       ahí la conversión es la reserva directa y la píldora tapaba Consultar;
     · mientras otro enlace de WhatsApp de la página está a la vista (el botón
       de Reservas, los de cada tour o habitación, el del pie), también: la
       píldora repetía ese enlace y tapaba el texto de alrededor.
   Arranca oculta (clase en el HTML) y aparece al terminar la revelación del
   preloader: antes aparecía y se ocultaba en la carga, o saltaba desde el
   pie del documento, y eso contaba como salto de diseño (CLS).
   En escritorio no se aparta al leer. Sube por encima del buscador del hero
   mientras está a la vista: en su esquina tapaba el borde de Consultar
   (2026-10-13).
   En todos los tamaños le cede el paso a un botón o enlace de acción que
   pase por debajo (2026-10-20, decisión del usuario): en escritorio tapaba
   «Reservar directo» de la tarjeta del mapa a 1440×900, y «Cómo llegar» y
   los enlaces de Experiencias en laptops. Baja fuera de la pantalla y vuelve
   en cuanto el botón queda libre.
   Un umbral evita que tiemble con el rebote del scroll en iOS.
   ============================================================================= */
(function () {
  'use strict';

  var wa = document.querySelector('.wa-float');
  if (!wa) return;

  var MOVIL = matchMedia('(max-width: 900px)');
  var UMBRAL = 12;          // px recorridos en una dirección antes de cambiar
  var ultimoY = window.scrollY, acumulado = 0, pendiente = false;
  var oculta = wa.classList.contains('is-oculta');

  /* Buscador del hero y enlaces de WhatsApp a la vista. IntersectionObserver
     en vez de medir cada enlace en cada scroll: son decenas entre tours,
     habitaciones y pie. El margen inferior descuenta la barra del marco. */
  var aLaVista = new Set();
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) aLaVista.add(e.target); else aLaVista.delete(e.target);
    });
    pedir();
  }, { rootMargin: '0px 0px -64px 0px' }) : null;

  function observar() {
    if (!io) return;
    document.querySelectorAll('.page .hero .avail, .page a[href*="wa.me"]').forEach(function (el) { io.observe(el); });
  }

  function contactoVisible(soloBuscador) {
    var hay = false;
    aLaVista.forEach(function (el) {
      if (!hay && el.isConnected && el.closest('.page.active') &&
          (!soloBuscador || el.classList.contains('avail'))) hay = true;
    });
    return hay;
  }

  /* Botones que pasan por debajo. Un segundo observador vigila solo la
     franja baja derecha donde se apoya la píldora; el cálculo fino (cruce
     real con la píldora y que el botón se vea, no tapado por otra escena)
     corre únicamente para los que están en ella. Fotos de la galería,
     preguntas del FAQ y tarjetas no cuentan: la píldora tapa una esquina,
     no la acción. */
  // Los llamados a reservar son píldoras desde el 2026-10-22 (contorno como
  // el flyer) y trazo.js ya no los marca .trazo-boton (sólo rectangulares):
  // se nombran aquí.
  var BOTONES = '.page :is(.trazo-boton, .cta-reservar, .rc-book, .rooms-info-cta, .welcome-wa, .rc-more, .itin-link, .home-map-directions, ' +
    '.hab-ver, .hab-fotos, .hab-wa, .cbtn, .rv-submit, .stack-reset, .reviews-arrow), footer a';
  var AIRE = 8;            // px de holgura alrededor de la píldora
  var ELEVACION = 128;     // px: .wa-float.is-elevada en site.css
  var enFranja = new Set(), franja = null;

  // Dónde queda la píldora en reposo. Oculta lleva transform, así que se
  // calcula desde right/bottom y su tamaño, no con getBoundingClientRect.
  function reposo() {
    var cs = getComputedStyle(wa);
    var der = document.documentElement.clientWidth - parseFloat(cs.right);
    var abajo = innerHeight - parseFloat(cs.bottom) - (elevada ? ELEVACION : 0);
    return { left: der - wa.offsetWidth - AIRE, right: der + AIRE, top: abajo - wa.offsetHeight - AIRE, bottom: abajo + AIRE };
  }

  function vigilarFranja() {
    if (franja) franja.disconnect();
    enFranja.clear();
    if (!('IntersectionObserver' in window)) return;
    var r = reposo();
    var arriba = Math.max(0, r.top - (MOVIL.matches ? 0 : ELEVACION));
    franja = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) enFranja.add(e.target); else enFranja.delete(e.target);
      });
      pedir();
    }, { rootMargin: -arriba + 'px 0px 0px ' + -Math.max(0, r.left) + 'px' });
    document.querySelectorAll(BOTONES).forEach(function (el) { franja.observe(el); });
  }

  var revision = 0, ultimaPrueba = -Infinity, ultimoTapa = false;
  function tapaBoton() {
    clearTimeout(revision);
    if (!enFranja.size) return false;
    // La prueba (medidas y elementsFromPoint, que obliga a terminar el layout
    // pendiente del cuadro) corre como mucho cada 100 ms, y cada 200 en modo
    // ligero: a 60 cuadros/s era un layout forzado por cuadro (medido: 3,5 %
    // del hilo en un equipo 2× más lento) para una decisión que a 10/s se ve
    // igual.
    var ahora = performance.now();
    if (ahora - ultimaPrueba < (window.MODO_LIGERO ? 200 : 100)) return ultimoTapa;
    ultimaPrueba = ahora;
    var r = reposo(), tapa = false, cruce = false;
    enFranja.forEach(function (el) {
      if (tapa || !el.isConnected) return;
      var c = el.getBoundingClientRect();
      var x0 = Math.max(c.left, r.left), x1 = Math.min(c.right, r.right);
      var y0 = Math.max(c.top, r.top), y1 = Math.min(c.bottom, r.bottom);
      if (x1 <= x0 || y1 <= y0) return;
      cruce = true;
      if (el.checkVisibility && !el.checkVisibility({ opacityProperty: true, visibilityProperty: true })) return;
      // El primer elemento en ese punto que no sea la píldora: si es el
      // botón, se ve; si es otra escena encima, no hay nada que despejar.
      var pila = document.elementsFromPoint((x0 + x1) / 2, (y0 + y1) / 2);
      for (var i = 0; i < pila.length; i++) {
        if (wa.contains(pila[i])) continue;
        tapa = el === pila[i] || el.contains(pila[i]);
        break;
      }
    });
    // Un botón bajo la píldora puede aparecer o taparse sin scroll (la
    // tarjeta del mapa se revela por tiempo, con la mancha): mientras haya
    // cruce se vuelve a mirar cada 0,4 s.
    if (cruce) revision = setTimeout(pedir, 400);
    ultimoTapa = tapa;
    return tapa;
  }

  var elevada = false;
  function elevar(v) {
    if (v === elevada) return;
    elevada = v;
    wa.classList.toggle('is-elevada', v);
  }

  function poner(v) {
    if (v === oculta) return;
    oculta = v;
    wa.classList.toggle('is-oculta', v);
  }

  /* Durante la revelación del preloader #app-shell lleva transform: la
     píldora (position: fixed dentro de él) queda al pie del documento y, al
     terminar, salta a la pantalla — otro salto de diseño. Espera oculta. */
  var shell = document.getElementById('app-shell'), shellQuieto = false;
  // getComputedStyle en cada cuadro costaba un recálculo de estilo; en cuanto
  // la revelación termina (transitionend) se recuerda y no se vuelve a mirar.
  function shellMovido() {
    if (!shell || shellQuieto) return false;
    if (getComputedStyle(shell).transform !== 'none') return true;
    shellQuieto = !shell.classList.contains('pre-reveal');
    return false;
  }
  // Al terminar la revelación se decide ya, sin esperar otro gesto: como
  // antes de esperarla, a mitad de página la píldora queda visible.
  if (shell) shell.addEventListener('transitionend', function (e) {
    if (e.target !== shell || shellMovido()) return;
    acumulado = 0;
    ultimoY = window.scrollY;
    elevar(!MOVIL.matches && contactoVisible(true));
    poner((MOVIL.matches && contactoVisible()) || tapaBoton());
  });

  function medir() {
    pendiente = false;
    var y = window.scrollY, dy = y - ultimoY;
    ultimoY = y;
    if (shellMovido()) { poner(true); return; }
    elevar(!MOVIL.matches && contactoVisible(true));
    // En escritorio también cede ante el buscador: con la portada nueva la píldora cubre su borde superior.
    if (!MOVIL.matches) { acumulado = 0; poner(tapaBoton() || contactoVisible(true)); return; }
    if (contactoVisible()) { acumulado = 0; poner(true); return; }
    if (tapaBoton()) { poner(true); return; }
    if (y <= 0) { acumulado = 0; poner(false); return; }
    if (dy && (dy > 0) !== (acumulado > 0)) acumulado = 0;   // cambió de dirección
    acumulado += dy;
    if (acumulado > UMBRAL) poner(true);
    else if (acumulado < -UMBRAL) poner(false);
  }

  function pedir() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(medir);
  }

  addEventListener('scroll', pedir, { passive: true });
  addEventListener('resize', pedir, { passive: true });
  // La franja depende del alto de la ventana y del ancho de la píldora.
  var reencuadre;
  addEventListener('resize', function () {
    clearTimeout(reencuadre);
    reencuadre = setTimeout(vigilarFranja, 200);
  }, { passive: true });
  // Al cambiar de página goTo() vuelve arriba con la cortina puesta; si ya
  // estaba arriba no hay scroll que avise, y la píldora quedaría como en la
  // página anterior. El observador avisa cuando la página nueva se muestra.
  addEventListener('hashchange', function () {
    acumulado = 0;
    ultimoY = window.scrollY;
    pedir();
  });
  // El catálogo de habitaciones vuelve a pintar sus enlaces al cambiar de
  // idioma, y la etiqueta de la píldora cambia de ancho.
  document.addEventListener('i18n:change', function () { observar(); vigilarFranja(); });
  // La letra web llega después de este script (font-display: swap): la
  // etiqueta cambia de ancho y una franja medida con la de respaldo quedaba
  // corrida y no veía «Reservar directo» del mapa (2026-10-22, al pasar a
  // Montserrat). Se vuelve a medir cuando la píldora cambia de tamaño.
  if ('ResizeObserver' in window) {
    var anchoPildora = wa.offsetWidth;
    new ResizeObserver(function () {
      if (wa.offsetWidth === anchoPildora) return;
      anchoPildora = wa.offsetWidth;
      clearTimeout(reencuadre);
      reencuadre = setTimeout(vigilarFranja, 200);
    }).observe(wa);
  }
  observar();
  vigilarFranja();
  // Con observador, la primera decisión espera su primer aviso: decidir antes
  // mostraría la píldora un instante sobre el buscador.
  if (!io) pedir();
})();
